module.exports = __webpack_public_path__ + "img/frame_1.b5189bd.png";